import React, { createContext, useContext, useMemo, useState } from 'react';

type TopChromeOffsetValue = {
  /** Altura total del bloque AppTopBanners (incluye inset superior si aplica). */
  globalBannerHeight: number;
  setGlobalBannerHeight: (height: number) => void;
};

const TopChromeOffsetContext = createContext<TopChromeOffsetValue>({
  globalBannerHeight: 0,
  setGlobalBannerHeight: () => {},
});

export function TopChromeOffsetProvider({ children }: { children: React.ReactNode }) {
  const [globalBannerHeight, setGlobalBannerHeight] = useState(0);
  const value = useMemo(
    () => ({ globalBannerHeight, setGlobalBannerHeight }),
    [globalBannerHeight],
  );
  return <TopChromeOffsetContext.Provider value={value}>{children}</TopChromeOffsetContext.Provider>;
}

export function useTopChromeOffset() {
  return useContext(TopChromeOffsetContext);
}
